import React, { useState } from 'react'
import Autocomplete, {
  createFilterOptions,
} from '@material-ui/lab/Autocomplete'
import { Paper } from '@material-ui/core'
import { OrangeTextField } from './styles'

const MultiSelect = ({
  items,
  label,
  onChange,
  limitTags,
  inputState,
  placeholder,
  originalArr,
  initialValue,
  noOptionsText,
  selectAllLabel,
  onChangeinputValue,
}) => {
  const [selectedOptions, setSelectedOptions] = useState(initialValue)
  const filter = createFilterOptions()

  const allSelected = items.length === selectedOptions.length
  const handleToggleOption = (selectedOptions) =>
    setSelectedOptions(selectedOptions)

  const handleClearOptions = () => setSelectedOptions([])

  const getOptionLabel = (option) => `${option.label}`

  // la siguiente funcion ayuda  a seleccionar los tags del select
  // y eliminar posibles repetidos en la ui
  const handleSelectAll = (isSelected) => {
    if (isSelected) {
      const allitems = selectedOptions.concat(items)
      const reOrder = allitems.reduce((acc, item) => {
        if (!acc.find((d) => d.label === item.label)) {
          acc.push(item)
        }
        return acc
      }, [])

      setSelectedOptions(reOrder)
    } else {
      handleClearOptions()
      onChange([])
    }
  }

  const handleToggleSelectAll = () => {
    handleSelectAll && handleSelectAll(!allSelected)
  }

  // envio de la informacion al formulario
  const handleChange = (event, selectedOptions, reason) => {
    if (reason === 'select-option' || reason === 'remove-option') {
      if (selectedOptions.find((option) => option.value === 'select-all')) {
        handleToggleSelectAll()
        const resultItems = items.filter((el) => el.value !== 'select-all')
        const withoutSelect = selectedOptions.filter(
          (item) => item.value !== 'select-all',
        )
        const allitems = withoutSelect.concat(resultItems)
        const reOrder = allitems.reduce((acc, item) => {
          if (!acc.find((d) => d.label === item.label)) {
            acc.push(item)
          }
          return acc
        }, [])
        return onChange(reOrder)
      } 
        const updateList = Array.from(
          new Set(
            [...originalArr].filter((item) =>
              new Set(selectedOptions.map((option) => option.label)).has(
                item.label,
              ),
            ),
          ),
        )
        handleToggleOption && handleToggleOption(updateList)
        return onChange(updateList)
      
    } if (reason === 'clear') {
      handleClearOptions && handleClearOptions()
      onChange([])
    }
  }

  return (
    <Autocomplete
      multiple
      filterSelectedOptions
      size="small"
      limitTags={limitTags}
      options={items}
      value={selectedOptions}
      inputValue={inputState || ''}
      onInputChange={(event, newInputValue) => {
        onChangeinputValue(newInputValue)
      }}
      getOptionLabel={getOptionLabel}
      getOptionSelected={(option, anotherOption) =>
        option.value === anotherOption.value
      }
      noOptionsText={noOptionsText}
      filterOptions={(options, params) => {
        const filtered = filter(options, params)
        return allSelected
          ? [...filtered]
          : [{ label: selectAllLabel, value: 'select-all' }, ...filtered]
      }}
      onChange={handleChange}
      renderInput={(params) => (
        <OrangeTextField {...params} label={label} placeholder={placeholder} />
      )}
      PaperComponent={(props) => (
        <Paper {...props} style={{ height: '150px' }} />
      )}
    />
  )
}

MultiSelect.defaultProps = {
  limitTags: 5,
  items: [],
  selectedValues: [],
  getOptionLabel: (value) => value,
}

export default MultiSelect
